import { Types } from '@grandvisionhq/graphql';

const shouldShowBackInStockNotification = (variant)=>{
    if (variant.__typename === 'FrameVariant' || variant.__typename === 'SunglassesVariant') {
        var ref, ref1;
        const { channelAvailability  } = variant.variantTypeDetails;
        const isInStoreOnly = channelAvailability === 'IN_STORE_ONLY';
        return !variant.isExcludedFromCheckout && !isInStoreOnly && ((ref = variant.inventory) === null || ref === void 0 ? void 0 : ref.stockIndicator) === Types.StockIndicator.OUT_OF_STOCK && !variant.isAllowBackOrder && !!((ref1 = variant.inventory.items[0]) === null || ref1 === void 0 ? void 0 : ref1.allowBackInStockNotification);
    }
    return false;
};

export { shouldShowBackInStockNotification };
//# sourceMappingURL=should-show-back-in-stock-notification.js.map
